import { Slot, Stack, useLocalSearchParams } from 'expo-router';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

export default function StaticPageLayout() {
  const { title = '' } = useLocalSearchParams<{ title: string; staticPage: string }>();
  return (
    <Stack
      screenOptions={{
        header: getScreenTitleHeader({ backStyle: 'close', cannotGoBackHref: '/' }),
        title,
      }}
    >
      {/*
          The purpose of using a Slot here is to make it so static pages do not stack on top of each other
          and will instead replace each other.
          This is desirable because of the way static pages inject <style> elements and other markup.
          If we do not remove a previous static page, it's styles can effect a totally separate page.
      */}
      <Slot />
    </Stack>
  );
}
